import { E_PASTE_BEHAVIOR_MODE, E_VIEW_MODE } from '@/components/editor/ThinkEditor.Defined';

export const DemoCaseCheckUserId = {
  methods: {
    async DoDemoCaseCheckUserId() {
      let editorsTabsView = this.defaultEditorsTabsView;
      let currentEditorsInstance = editorsTabsView.editorsInstance;

      var docName = '同用户可粘贴';
      let thinkEditor = currentEditorsInstance.GetEditor(docName);

      if (thinkEditor === undefined) {
        thinkEditor = await editorsTabsView.CreateDocEditor(docName);

        var url = '/system/emr/演示/00-演示病例/AdmissionRecord.xml';
        let response = await fetch(url, {
          credentials: 'same-origin'
        });
        let xml = await response.arrayBuffer();

        thinkEditor.CreateDoc(docName); //@20220722 必需，才能设置编辑者信息
        thinkEditor.SelectDoc(docName);

        thinkEditor.ParseDocs(docName, '', xml, {});

        thinkEditor.SetUserProfile({ terminal: 'pc', id: 'appGuid1', name: '主治医生1', level: 1, claims: '主治医生' });

        /*************************************************
         * 配置跨病历编辑 权限控制必要参数
         * **********************************************/
        thinkEditor.SetDocConfig('', { userId: 'user1', userName: '张三', pasteCheckUserIdMode: E_PASTE_BEHAVIOR_MODE.UserChoose }); //文档有docId时并且pasteCheckDocIdMode>0 才会检查同文档可粘贴行为

        thinkEditor.SetViewMode(E_VIEW_MODE.Edit, {});
      }
      //UI 中显示该文档
      editorsTabsView.SelectDocEditor(docName);
    },

    async OnPasteCheckUserIdModeChange(value) {
      let currentTabsView = this.defaultEditorsTabsView;
      let currentEditorsInstance = currentTabsView.editorsInstance;
      let currentThinkEditor = currentEditorsInstance.GetSelectedEditor();
      if (currentThinkEditor === undefined) {
        return;
      }

      currentThinkEditor.SetDocConfig('', { pasteCheckUserIdMode: value });
    }
  }
};
